export default "/images/processor-placeholder-logo.png?699a5265f3de8d1978f1ddbf2896b874";